(function () {
    var root = document.getElementById('cardsCarousel');
    var viewport = root.querySelector('.cards-carousel__viewport');
    var track = root.querySelector('.cards-carousel__track');
    var prevArrow = root.querySelector('[data-role="prev"]');
    var nextArrow = root.querySelector('[data-role="next"]');

    function getStep() {
        var first = track.querySelector('.cards-carousel__item');
        if (!first) return 0;
        var style = window.getComputedStyle(first);
        var mr = parseFloat(style.marginRight || '20');
        return first.getBoundingClientRect().width + mr;
    }

    prevArrow.addEventListener('click', function () {
        viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    nextArrow.addEventListener('click', function () {
        viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    var items = track.querySelectorAll('.cards-carousel__item');
    if (!items.length) return;

    var firstItem = items[0];
    var lastItem = items[items.length - 1];

    var ioOptions = {
        root: viewport,
        rootMargin: '0px',
        threshold: 0.85
    };

    var firstVisible = false;
    var lastVisible = false;

    function applyArrowVisibility() {
        prevArrow.classList.toggle('cards-carousel__arrow--hidden', firstVisible);
        nextArrow.classList.toggle('cards-carousel__arrow--hidden', lastVisible);
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.target === firstItem) {
                firstVisible = entry.isIntersecting && entry.intersectionRatio >= ioOptions.threshold;
            } else if (entry.target === lastItem) {
                lastVisible = entry.isIntersecting && entry.intersectionRatio >= ioOptions.threshold;
            }
        });
        applyArrowVisibility();
    }, ioOptions);

    observer.observe(firstItem);
    observer.observe(lastItem);

    function reobserve() {
        observer.disconnect();
        items = track.querySelectorAll('.cards-carousel__item');
        if (!items.length) return;
        firstItem = items[0];
        lastItem = items[items.length - 1];
        firstVisible = false;
        lastVisible = false;
        observer.observe(firstItem);
        observer.observe(lastItem);
        setTimeout(applyArrowVisibility, 0);
    }

    viewport.addEventListener('scroll', applyArrowVisibility);
    window.addEventListener('resize', reobserve);

    applyArrowVisibility();
})();
